export default {
  "exactanalytical.com.my": {
    template: "argon",
    asset: {
      logo: "/asset/exact/logo.png",
      favicon: "/asset/exact/favicon.png",
      favicon_16: "/asset/exact/favicon-16x16.png",
      favicon_32: "/asset/exact/favicon-32x32.png",
      apple_touch_icon: "/asset/exact/apple-touch-icon.png",
      manifest: "/asset/exact/site.webmanifest",
    },
    project: {
      name: `CEMS`,
      client: "CEMS",
      client_url: "https://www.exactanalytical.com.my/solutions-2/cems/",
      author: "Exact Analytical",
      author_url: "https://www.exactanalytical.com.my/",
    },
    colors: {
      blue: "#5e72e4",
      indigo: "#5603ad",
      purple: "#8965e0",
      pink: "#f3a4b5",
      red: "#f5365c",
      orange: "#fb6340",
      yellow: "#ffd600",
      green: "#2dce89",
      teal: "#11cdef",
      cyan: "#2bffc6",
      white: "#fff",
      gray: "#8898aa",
      "gray-dark": "#32325d",
      light: "#adb5bd",
      lighter: "#e9ecef",
      primary: "#5e72e4",
      secondary: "#f7fafc",
      success: "#2dce89",
      info: "#11cdef",
      warning: "#fb6340",
      danger: "#f5365c",
      dark: "#212529",
      default: "#172b4d",
      neutral: "#fff",
      darker: "black",
    },
    naiveui: {
      common: {
        // baseColor: '#5e72e4',
        primaryColor: "#5e72e4",
        primaryColorHover: "#5e72e4",
        primaryColorPressed: "#5e72e4",
        primaryColorSuppl: "#5e72e4",
      },
    },
  },
  "point.ada-ir.com": {
    template: "nexus",
    asset: {
      logo: "/asset/adair/logo.png",
      favicon: "/asset/adair/favicon.png",
      favicon_16: "/asset/adair/favicon-16x16.png",
      favicon_32: "/asset/adair/favicon-32x32.png",
      apple_touch_icon: "/asset/adair/apple-touch-icon.png",
      manifest: "/asset/adair/site.webmanifest",
    },
    project: {
      name: `Nexus Point`,
      client: "Nexus",
      client_url: "https://nexus.ada-ir.com/",
      author: "AdaIR Sdn Bhd",
      author_url: "https://ada-ir.com/",
    },
    naiveui: {
      common: {
        // baseColor: '#5e72e4',
        primaryColor: "#0a1f49",
        primaryColorHover: "#0a1f49",
        primaryColorPressed: "#0a1f49",
        primaryColorSuppl: "#0a1f49",
      },
    },
    colors: {
      blue: "#0a1f49",
      indigo: "#5603ad",
      purple: "#8965e0",
      pink: "#f3a4b5",
      red: "#f5365c",
      orange: "#fb6340",
      yellow: "#ffd600",
      green: "#2dce89",
      teal: "#11cdef",
      cyan: "#2bffc6",
      white: "#fff", // last defined value kept
      gray: "#8898aa",
      "gray-dark": "#32325d",
      light: "#adb5bd", // overwritten by the later one
      lighter: "#e9ecef",
      primary: "#0a1f49",
      secondary: "#edf0fe",
      success: "#2dce89",
      info: "#11cdef",
      warning: "#fb6340",
      danger: "#f5365c",
      dark: "#212529",
      default: "#172b4d",
      neutral: "#fff",
      darker: "black",
    },
  },
};
